import connectedAccountEN from './connected_account/connectedAccountEN.json';
import connectedAccountFR from './connected_account/connectedAccountFR.json';
import connectedBrandFR from './connected_brand/connectedBrandFR.json';
import connectedBrandEN from './connected_brand/connectedBrandEN.json';

const USER_PROFILE_EN = {
  ...connectedAccountEN,
  ...connectedBrandEN
};
const USER_PROFILE_FR = {
  ...connectedAccountFR,
  ...connectedBrandFR
};

export { USER_PROFILE_EN, USER_PROFILE_FR };
